import {
  insertNodes,
  InsertNodesOptions,
  PlateEditor,
  TText,
  Value,
} from '@udecode/plate-common';

import { MyInterlinkElement } from '../../../plateTypes';
import { createInterlinkNode, CreateInterlinkNodeOptions } from '../utils';

/** Insert an interlink node. */
export const insertInterlink = <V extends Value>(
  editor: PlateEditor<V>,
  createLinkNodeOptions: CreateInterlinkNodeOptions,
  options?: InsertNodesOptions<V>,
): void => {
  insertNodes<MyInterlinkElement | TText>(
    editor,
    [createInterlinkNode(editor, createLinkNodeOptions)],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options as any,
  );
};
